import React from 'react';
import { AuthenticationConsumer } from '../../core/services/AuthenticationProvider';
import { Loader } from '../../core/components';

export const SignInCallbackRoute = () => {
    return (
        <AuthenticationConsumer>
            {({signinRedirectCallback}) => {
                !signinRedirectCallback || signinRedirectCallback();
                
                return <Loader main={true} opacity={1} />
            }}
        </AuthenticationConsumer>
    ) 
}